/**
 * Cognito auth state listener - checks session on init and provides a way to trigger auth flow.
 * Cognito doesn't have onAuthStateChanged like Firebase, so we check session on startup
 * and manually trigger the flow after sign-in/sign-out.
 */
import { getCurrentCognitoUser } from './index'

export const checkCognitoSession = async (dispatch) => {
  try {
    const cognitoUser = await getCurrentCognitoUser()
    if (!cognitoUser) {
      dispatch('setFirebaseUser', null)
      return null
    }
    const authUser = {
      email: cognitoUser.username,
      uid: cognitoUser.userId || cognitoUser.username,
      emailVerified: true
    }
    window.firebaseUser = authUser
    dispatch('setFirebaseUser', authUser)
    return authUser
  } catch {
    dispatch('setFirebaseUser', null)
    return null
  }
}
